import { Fragment } from 'react/jsx-runtime'
import { getMessage } from '../../utils/messageUtils'
import type { recipe } from '../../utils/recipeUtils'
import CollapsibleSection from '../CollapsibleSection'
import './FilterBar.scss'

interface checkboxOption {
  label: string
  value: boolean
  setValue: React.Dispatch<React.SetStateAction<boolean>>
}
interface filter {
  labelClassName?: string
  label?: string
  type: string
  placeholder?: string
  value: string | boolean
  options?: string[]
  checkboxes?: checkboxOption[]
  setValue: React.Dispatch<React.SetStateAction<string | boolean>>
}

interface FilterBarProps {
  filters: filter[]
  openPopup: (obj: object | null) => void
  isMobile: boolean
}

function RecipeFilterBar({ filters, openPopup, isMobile }: FilterBarProps) {
  const handleNew = () => {
    openPopup(null)
  }

  const generateFilterItems = () => {
    const labelClass = 'filter-label' + (isMobile ? ' filter-label-mobile' : '')
    const checkboxContainerClass = `filter-checkbox-container ${isMobile ? 'filter-checkbox-container-mobile' : ''}`

    return (
      <div className={`filter-bar ${isMobile ? 'filter-bar-mobile' : ''}`}>
        <span className={labelClass}>{getMessage('filter_by')}:</span>
        {filters.map(filter => {
          let input = null
          if (filter.type === 'text') {
            input = (
              <input
                className={`text-filter ${isMobile ? 'text-filter-mobile' : ''}`}
                type="text"
                placeholder={filter.placeholder}
                value={filter.value as string}
                onChange={e => filter.setValue(e.target.value)}
              />
            )
          } else if (filter.type === 'select') {
            input = (
              <select
                className={`combo-filter ${isMobile ? 'combo-filter-mobile' : ''}`}
                value={filter.value as string}
                onChange={e => filter.setValue(e.target.value)}
              >
                <option value=""></option>
                {filter.options!.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            )
          } else if (filter.type === 'checkbox' && filter.checkboxes) {
            input = (
              <div
                className={`filter-checkbox-group ${isMobile ? 'filter-checkbox-group-mobile' : ''}`}
              >
                {filter.checkboxes.map(checkbox => (
                  <label className={checkboxContainerClass}>
                    <input
                      className="filter-checkbox"
                      type="checkbox"
                      checked={checkbox.value}
                      onChange={e => checkbox.setValue(e.target.checked)}
                    />{' '}
                    {checkbox.label}
                  </label>
                ))}
              </div>
            )
          }

          return (
            <Fragment>
              {filter.label ? (
                <span
                  className={`${filter.labelClassName ? filter.labelClassName : ''}${labelClass}`}
                >
                  {filter.label}:
                </span>
              ) : null}
              {input}
            </Fragment>
          )
        })}
        <div
          className={`filter-bar-button-group ${isMobile ? 'filter-bar-button-group-mobile' : ''}`}
        >
          <button className="filter-bar-button" onClick={handleNew}>
            {getMessage('add')}
          </button>
        </div>
      </div>
    )
  }

  if (isMobile) {
    return (
      <CollapsibleSection
        title={getMessage('options')}
        defaultOpen={false}
        isMobile={isMobile}
      >
        {generateFilterItems()}
      </CollapsibleSection>
    )
  } else {
    return generateFilterItems()
  }
}

export default RecipeFilterBar

export type { filter }
